import { useEffect, useState } from 'react';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useLocation } from 'react-router-dom';
import { FeatureFlags } from '@marqvision/shared';
import { checkIsActiveClient } from '~/components/productMarketingMaterials/@utils';
import { AuthProtocolsGetUserInfoResponse } from '~/swagger/data-contracts';
import { PmmLocalStorage } from '../@types';
import { usePmmLocalStorage } from '../@hooks';
import { TARGET_TICKET_NUMBER } from '../@constants';

export const usePmmReleaseNoteDialog = (userInfo: AuthProtocolsGetUserInfoResponse) => {
  const isPmmOn = useFeatureIsOn(FeatureFlags['brand-client-product-marketing-material']);

  const { parsedData, handleSetPmmData } = usePmmLocalStorage<PmmLocalStorage>();
  const isActiveClient = checkIsActiveClient(userInfo);

  const isGlobalDialogExposed = !!parsedData?.[TARGET_TICKET_NUMBER]?.globalReleaseNoteDialogExposed;
  const isGlobalDialogDoNotShowAgain = !!parsedData?.[TARGET_TICKET_NUMBER]?.globalReleaseNoteDialogDoNotShowAgain;

  const currentLocation = useLocation();
  const isHomePage = currentLocation.pathname === '/home';

  const showDialog =
    isPmmOn && // Feature Flag가 켜져있어야 하고,
    isActiveClient && // 타겟 클라이언트에 포함되어 있어야 하고,
    !isGlobalDialogDoNotShowAgain && // 티켓에 해당하는 Dialog에서 Do not show again 을 선택하지 않았어야 하고,
    (isGlobalDialogExposed ? isHomePage : true); // 이미 Dialog를 본적이 있다면 `/home` 에서만 자동 노출시켜야 함
  const [isOpen, setIsOpen] = useState<boolean>(showDialog);

  useEffect(() => {
    setIsOpen(showDialog);
  }, [showDialog]);

  const handleDoNotShowAgainClick = () => {
    handleSetPmmData((prev) => ({
      ...prev,
      [TARGET_TICKET_NUMBER]: {
        ...prev[TARGET_TICKET_NUMBER],
        globalReleaseNoteDialogDoNotShowAgain: true,
        globalReleaseNoteDialogExposed: true,
      },
    }));
    setIsOpen(false);
  };
  const handleGotItClick = () => {
    handleSetPmmData((prev) => ({
      ...prev,
      [TARGET_TICKET_NUMBER]: {
        ...prev[TARGET_TICKET_NUMBER],
        globalReleaseNoteDialogExposed: true,
      },
    }));
    setIsOpen(false);
  };

  return {
    isOpen,
    onDoNotShowAgainClick: handleDoNotShowAgainClick,
    onGotItClick: handleGotItClick,
  };
};
